import React from 'react'
import PropTypes from "prop-types"
import { RichText } from 'prismic-reactjs'
import { ThemeProvider } from "styled-components"

import { Container } from './button.styles'

const Button = (props) => {
	const { label, ...containerProps } = props

	return (
		<Container {...props}>
			{label}
		</Container>
	)
}

export default Button;